import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { t } from '@insight/toolkit-utils/lib/labels'

export default function PartNumbers(props) {
  const { className, inline, insightPart, mfrPart, unspsc, depOrgId } = props

  const classNames = cn(
    { 'c-structured-list--inline': inline, 'c-structured-list': !inline },
    'c-part-numbers u-margin-bot',
    className
  )
  return (
    <div className={classNames}>
      <div className="c-structured-list__items">
        {!!insightPart && (
          <div className="c-structured-list__item">
            <span className="c-structured-list__term">
              {t('Insight #:')}
            </span>
            <span className="c-structured-list__description">{insightPart}</span>
          </div>
        )}
        {!!mfrPart && (
          <div className="c-structured-list__item">
            <span className="c-structured-list__term">
              {t('Mfr #:')}
            </span>
            <span className="c-structured-list__description">{mfrPart}</span>
          </div>
        )}
        {!!unspsc && (
          <div className="c-structured-list__item">
            <span className="c-structured-list__term">
              {t('UNSPSC #:')}
            </span>
            <span className="c-structured-list__description">{unspsc}</span>
          </div>
        )}
        {!!depOrgId && (
          <div className="c-structured-list__item">
            <span className="c-structured-list__term">
              {t('DEP Org ID #:')}
            </span>
            <span className="c-structured-list__description">{depOrgId}</span>
          </div>
        )}
      </div>
    </div>
  )
}

PartNumbers.propTypes = {
  className: PropTypes.string,
  inline: PropTypes.bool,
  insightPart: PropTypes.string,
  mfrPart: PropTypes.string,
  unspsc: PropTypes.string,
  depOrgId: PropTypes.string,
}

PartNumbers.defaultProps = {
  className: '',
  inline: false,
  insightPart: '',
  mfrPart: '',
  unspsc: '',
  depOrgId: '',
}
